<style lang="scss" scoped>
.logincontainer {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100vh;

  .logintext {
    text-align: center;
    index: 1;
    h1 {
      color: $c-dark-grey !important;
      font-size: 13vw !important;
      letter-spacing: 6px !important;
    }

    h2 {
      font-size: 5vw !important;
    }

    @media (min-width: 1024px) {
      text-align: right;
      position: absolute;
      bottom: 10%;
      right: 20%;
      width: 50%;

      h1 {
        font-size: 150px !important;
      }

      h2 {
        font-size: 40px !important;
      }
    }
  }
}

.targetcircles {
  right: 0;
  top: 0;
  z-index: 0;

  //transform: translateY(-50%);
  position: absolute;
  height: 100vh;
  width: 100vh;
  //border: 1px solid red;
  transform: translateX(35%);

  .circle {
    border: 40px solid $c-medium-gray;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-name: slidein;
    animation-duration: 2s;
    animation-iteration-count: 1;
  }

  .circle1 {
    height: 100%;
    width: 100%;
  }
  .circle2 {
    height: 80%;
    width: 80%;
  }
  .circle3 {
    height: 70%;
    width: 70%;
  }
}

#loginpage {
  position: relative;
  height: 100vh;

  .logocontainer {
    margin-top: 10vh;
    margin-bottom: 5vh;
    .logo {
      max-width: 200px;
    }
  }

  .splash {
    // animation-name: slidein2;
    // animation-duration: 2.5s;
    // animation-iteration-count: 1;
  }
}

@keyframes slidein {
  from {
    opacity: 0.5;
    transform: translate(50%, -50%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

@keyframes slidein2 {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>

<template>
  <div class="logincontainer">
    <div class="targetcircles">
      <div class="circle1 circle">
        <div class="circle2 circle">
          <div class="circle3 circle"></div>
        </div>
      </div>
    </div>
    <div class="container" id="loginpage">
      <div class="row">
        <div class="col-6 col-lg-2 offset-lg-2 logocontainer text-center">
          <img class="logo" src="@/assets/0220-2101-HR-Visual-RGB-dunkel.svg" />
        </div>
      </div>

      <div class="row">
        <div class="row">
          <div class="col-12 col-lg-4 offset-lg-1">
            <LabeledInput label="BENUTZERNAME" v-model="username" />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-4 offset-lg-1 mt-3">
            <LabeledInput label="PASSWORT" v-model="password" type="password" />
          </div>
        </div>

        <div class="row">
          <div class="col-6 col-lg-2 offset-lg-1 mt-3">
            <button @click="login">JETZT EINLOGGEN</button>
          </div>
        </div>
      </div>
      <div class="logintext splash">
        <h1>Skill Base</h1>
        <h2>Der Styria Human Ressources</h2>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default defineComponent({
  setup() {
    const username = ref();
    const password = ref();
    const store = useStore();
    const router = useRouter();

    const login = () =>
        store
            .dispatch('login', { username: username.value, password: password.value })
            .then(() => {
              store.dispatch('addNotification', { type: 'sucess', message: 'Willkommen!' });
              router.push({ name: 'Index' });
            })
            .catch(() => {
              store.dispatch('addNotification', { type: 'error', message: 'Falscher Username oder Passwort' });
            });

    return {
      username,
      password,
      login,
    };
  },
});
</script>
